import { render, staticRenderFns } from "./QHqLoginsStaffDrilldown.vue?vue&type=template&id=527c0012&scoped=true&"
import script from "./QHqLoginsStaffDrilldown.vue?vue&type=script&lang=js&"
export * from "./QHqLoginsStaffDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527c0012",
  null
  
)

export default component.exports